import React, { useEffect } from "react";
import PageHeaderSmall from "../../components/PageHeaderSmall";
import ContentRight from "../../components/ContentRight";
import { careersContent } from "../../page-content/careers/careers-content";

const Careers = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const title = "Careers";
  return (
    <>
      <PageHeaderSmall title={title} />
      <ContentRight data={careersContent} />
    </>
  );
};

export default Careers;
